import React, { useState, useEffect, useCallback, useRef } from 'react';
import parse from 'html-react-parser';
import useFetchGetToken from '../../Services/GetToken';
import GetFetchWithToken from '../../Services/GetFetchWithToken';
import { getEntities, gatewayInteraction } from "../../Services/IMGatewayInteractionService"
import { Row, Col, Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import Banner from '../../components/banner.js';
import Sidebar from '../../components/sidebar.js';
import Modal from 'react-bootstrap/Modal';
import { useHistory, useParams, useLocation } from "react-router-dom";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { IconSearch, IconInfoTriangleFilled,IconArrowBadgeUpFilled, IconZoomCheckFilled, IconFilterFilled, IconX, IconCirclePlusFilled, IconTrash, IconExternalLink, IconRestore, IconArrowRight } from '@tabler/icons-react'; // Import Icon
import { useMediaQuery, Divider, TextField, Checkbox, InputAdornment, CircularProgress,  Alert, AlertTitle, Chip, Typography, IconButton, FormControl, FormLabel, Button, Tooltip, FormControlLabel,FormGroup, Autocomplete, Tab, Tabs, Box,Table, TableBody, TableFooter, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Pagination, Badge, Fab, Zoom, List, ListItem, ListItemIcon, ListItemText, Stack, Dialog, DialogActions, DialogContent, DialogTitle  } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import '../../styles/IMGatewayHerbalInteractions.scss'
import { logPageViews } from '../../Services/LoginService.js';
import Illustration from '../../assets/ModuleIllustrations/IMGatewayIllustration.svg';

const IMGatewayHerbalInteractions = () => {
    const [activeButton, setActiveButton] = useState('imgateway');
    const [token, setToken] = useState('');
    const [getdatas, setgetdatas] = useState([]);
    const [entities, setEntities] = useState([]);
    
    function showLoader() {
        const el = document.getElementById("loader");
        if (el) {
          console.log("Before:", el.style.display);
          el.style.setProperty("display", "flex", "important");
          el.style.zIndex = "1000";
          console.log("After:", el.style.display);
        }
    }

    function hideLoader() {
        const el = document.getElementById("loader");
        if (el) {
        el.style.display = "none";
        }
    }

    // Fetching data set
    useEffect(() => {
        document.title = "IMGateway Herbal Interactions";
        logPage("IMGateway", "", "");
    
        const fetchData = async () => {
            showLoader();
            try {
                const items = await getEntities();
                setEntities(items);
            } catch (error) {
                console.error("Error fetching entities:", error);
            } finally {
                hideLoader();
            }
        };
    
        fetchData();
    }, []);
    const theme = useTheme();
    
          const transitionDuration = {
            enter: theme.transitions.duration.enteringScreen,
            exit: theme.transitions.duration.leavingScreen,
          };
    const handleScrollUp = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      };
    const isLgScreen = useMediaQuery('(min-width:1024px)');
    //Make search filters float after scrolling
    const sentinelRef = useRef(null);
    const [isFloating, setIsFloating] = useState(false);
    const [isFloatingMobile, setIsFloatingMobile] = useState(false);
    useEffect(() => {
        if (isLgScreen) {
            setIsFloatingMobile(false);
            const observer = new IntersectionObserver(
                ([entry]) => {
                    setIsFloating(!entry.isIntersecting);
                },
                {
                    root: null,
                    threshold: 0,
                }
                );
        
                if (sentinelRef.current) {
                observer.observe(sentinelRef.current);
                }
        
                return () => {
                if (sentinelRef.current) {
                    observer.unobserve(sentinelRef.current);
                }
                };
        }
        else{
            setIsFloating(false);
            const observer = new IntersectionObserver(
                ([entry]) => {
                    setIsFloatingMobile(!entry.isIntersecting);
                },
                {
                    root: null,
                    threshold: 0,
                }
                );
        
                if (sentinelRef.current) {
                observer.observe(sentinelRef.current);
                }
        
                return () => {
                if (sentinelRef.current) {
                    observer.unobserve(sentinelRef.current);
                }
                };
        }
        
        
    }, [isLgScreen]);
    
    const [dataHerb, setDataHerb] = useState('');
    const [dataDrug, setDataDrug] = useState('');
    const [dataDrugClass, setDataDrugClass] = useState('');
    const [dataRecommendation, setDataRecommendation] = useState('');
    const [recommendationRanking, setRecommendationRanking] = useState('');
    const [dataPatientAdvise, setDataPatientAdvise] = useState('');
    const [dataEvidenceType, setDataEvidenceType] = useState('');
    const [dataGeneralCommentary, setDataGeneralCommentary] = useState('');
    const [dataReports, setDataReports] = useState([]);

    async function logPage(pageName, input1, input2) {
        await logPageViews(pageName, input1, input2)
    }

    function OnClickedTableRow(event) {
        setDataHerb(event.currentTarget.getAttribute("data-herb"));
        setDataDrug(event.currentTarget.getAttribute("data-drug"));
        setDataDrugClass(event.currentTarget.getAttribute("data-drugClass"));
        setDataRecommendation(event.currentTarget.getAttribute("data-recommendation"));
      
        setRecommendationRanking(
          ((rank) => Number.isNaN(rank) ? 0 : rank)(
            parseInt(event.currentTarget.getAttribute("data-recommendationRanking"), 10)
          )
        );
      
        setDataPatientAdvise(event.currentTarget.getAttribute("data-patientadvise"));
        setDataEvidenceType(event.currentTarget.getAttribute("data-evidenceType"));
        setDataGeneralCommentary(event.currentTarget.getAttribute("data-generalCommentary"));
      
        try {
          const parsedReports = JSON.parse(event.currentTarget.getAttribute("data-reports"));
          setDataReports(parsedReports);
        } catch (err) {
          console.error("Failed to parse reports:", err);
          setDataReports([]); // Fallback to empty array
        }
      
        setModalShow(true);
      
        logPage("IMGateway Details",
          event.currentTarget.getAttribute("data-herb"),
          event.currentTarget.getAttribute("data-drug")
        );
      }
      
    const [modalShow, setModalShow] = useState(false);
    function ResultModal (props) {
        return (
            <Modal
                {...props}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="IMGatewayResultsModal"
                dialogClassName={isLgScreen ? "" : "modal-dialog-scrollable"}
            >
                <Modal.Header closeButton >
                    <Modal.Title className="d-flex align-items-center flex-nowrap w-100">
                        <img src='../imgateway-logo.png' style={{ maxHeight: isLgScreen ? "48px" : "28px", width: "auto", marginRight: 12 }} /><img src="/unisyd-logo.svg" id="logo-img" alt="Logo" className="me-2" style={{ maxHeight: isLgScreen ? "48px" : "28px", width: "auto" }} />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='mb-3'>
                        <Col lg={12} className={isLgScreen ? "" : "p-0"}>
                            <div className='d-flex flex-column my-3'>
                            {isLgScreen ? (
                                <h4>
                                {dataHerb}
                                <span className="text-danger mx-2"> ⭤ </span>
                                {dataDrug || dataDrugClass}
                                </h4>
                            ) : (
                                <strong style={{fontSize: 18, color: "#202020"}}>
                                {dataHerb}
                                <strong className="text-danger mx-2">⭤</strong>
                                {dataDrug || dataDrugClass}
                                </strong>
                            )}
                            </div>
                            <div className= {isLgScreen ? 'd-flex my-3 align-items-center' : 'd-flex flex-column my-3 align-items-start'}>
                                <strong className={isLgScreen ? 'm-0' : "mb-2"}>GENERAL RECOMMENDATION</strong>
                                <Chip
                                    label={dataRecommendation}
                                    color={getRecommendationColor(recommendationRanking)}
                                    style={{
                                    backgroundColor: recommendationRanking === 3 ? "#E0A201" : undefined,
                                    color:  recommendationRanking === 3 ? "#ffffff" : undefined,
                                    fontSize: "12px",
                                    width: "fit-content",
                                    marginLeft: isLgScreen ? "16px" : 0,
                                    }}
                                />
                            </div>
                            <div className='d-flex flex-column my-3'>
                                <strong>Patient Advice</strong>
                                <span>{dataPatientAdvise}</span>
                            </div>
                            <div className= {isLgScreen ? 'd-flex my-3 align-items-center' : 'd-flex flex-column my-3 align-items-start'}>
                                <strong className={isLgScreen ? 'm-0' : "mb-2"}>EVIDENCE TYPE</strong>
                                <Chip
                                label={dataEvidenceType}
                                color={getEvidenceTypeColor(dataEvidenceType)}
                                variant="outlined"
                                sx={{ borderWidth: "3px", borderStyle: "solid",
                                width: "fit-content",
                                marginLeft: isLgScreen ? "16px" : 0, }}
                                />
                            </div>
                            <div className='d-flex flex-column my-3'>
                                <strong>General Commentary On Evidence</strong>
                                <span>{dataPatientAdvise}</span>
                            </div>
                            {dataReports.length > 0 && 
                            <div className='d-flex flex-column mt-3'>
                                <strong>REPORTS</strong>
                                <ul className= {isLgScreen ? 'mb-0' : 'mb-0 ps-3'}>
                                    {dataReports.map((item, index) => (
                                    <li key={index} className='mb-2'>
                                        <span
                                style={{
                                    cursor: "pointer",
                                    textDecoration: "none",
                                    color: "#0d6efd",
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.textDecoration = "underline"}
                                onMouseLeave={(e) => e.currentTarget.style.textDecoration = "none"}
                                onClick={() => onReportClick(item)}
                                >
                                {item.title}
                                </span>
                                    </li>
                                    ))}
                                </ul>
                            </div>
                            }
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }


    const [reportItem, setReportItem] = useState([])
    const [showReportModal, setShowReportModal] = useState(false);
    
    const onReportClick = (item) => {
        setReportItem(item);
        setShowReportModal(true);
        setModalShow (false)
      };

      function ReportModal (props) {
        return (
            <Modal size="xl"
                show={showReportModal}  
                onHide={() => {
                    setShowReportModal(false);
                    setModalShow(true);
                }} centered 
                className="IMGatewayResultsModal"
                dialogClassName={isLgScreen ? "" : "modal-dialog-scrollable"}>
                <Modal.Header closeButton>
                    <Modal.Title className="d-flex align-items-center flex-nowrap w-100" >
                        <h4 className='mb-0'style={{fontSize: !isLgScreen ? 16 : "", lineHeight: !isLgScreen ? 1.5 : ""}} >
                        {dataHerb}
                        <span className="text-danger mx-2"> ⭤ </span>
                        {dataDrug || dataDrugClass}
                        </h4>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className={!isLgScreen ? 'p-0 pt-3' : " "}>
                {reportItem && 
                    <>
                        {reportItem.title && <><h5 className="mt-2" style={{fontWeight:"bold", color: "#0262AB"}}>{reportItem.title}</h5></>}
                        {reportItem.citation && <>
                            <div className="d-flex flex-column my-3">
                                <strong>Citation</strong>
                                <span>
                                    {
                                    (() => {
                                        const citation = reportItem.citation || "";
                                        const urlMatch = citation.match(/https?:\/\/[^\s]+/);
                                        if (urlMatch) {
                                        const rawUrl = urlMatch[0];
                                        const trimmedUrl = rawUrl.replace(/[.,;!?)]*$/, ''); // for href only
                                        const startIndex = citation.indexOf(rawUrl);
                                        const endIndex = startIndex + rawUrl.length;
                                        return (
                                            <>
                                            {citation.slice(0, startIndex)}
                                            <a
                                                href={trimmedUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ wordBreak: "break-all" }}
                                            >
                                                {rawUrl}
                                            </a>
                                            {citation.slice(endIndex)}
                                            </>
                                        );
                                        }
                                        return citation;
                                    })()
                                    }
                                </span>
                            </div>

                        </>}
                        {reportItem.studyAim && <>
                            <div className='d-flex flex-column my-3'>
                                <strong>Study Aim</strong><span>{reportItem.studyAim}</span>
                            </div>
                        </>}
                        {reportItem.studyDesign && <>
                            <div className='d-flex flex-column my-3'>
                                <strong>Study Design</strong><span>{reportItem.studyDesign}</span>
                            </div>
                        </>}
                        {reportItem.pharmacokineticMethods && <>
                            <div className='d-flex flex-column my-3'>
                                <strong>Pharmacokinetic Methods</strong><span>{reportItem.pharmacokineticMethods}</span>
                            </div>
                        </>}
                        {reportItem.statisticalMethods && <>
                            <div className='d-flex flex-column my-3'>
                                <strong>Statistical Methods</strong><span>{reportItem.statisticalMethods}</span>
                            </div>
                        </>}
                        {reportItem.commentsOnEvidence && <>
                            <div className='d-flex flex-column my-3'>
                                <strong>Comments On Evidence</strong><span>{reportItem.commentsOnEvidence}</span>
                            </div>
                        </>}
                        {reportItem.results && <>
                            <div className='d-flex flex-column my-3'>
                                <strong>Results</strong><span>{reportItem.results}</span>
                            </div>
                        </>}
                        {reportItem.resultsDetails && <>
                            <div className='d-flex flex-column my-3'>
                                <strong>Results Details</strong><span>{reportItem.resultsDetails}</span>
                            </div>
                        </>}
                        {reportItem.discussion && <>
                            <div className='d-flex flex-column my-3'>
                                <strong>Discussion</strong><span>{reportItem.discussion}</span>
                            </div>
                        </>}
                        {reportItem.discussionDetails && <>
                            <div className='d-flex flex-column my-3'>
                                <strong>Discussion Details</strong><span>{reportItem.discussionDetails}</span>
                            </div>
                        </>}
                        {reportItem.implication && <>
                            <div className='d-flex flex-column my-3'>
                                <strong>Implication</strong><span>{reportItem.implication}</span>
                            </div>
                        </>}
                    </>
                }
                </Modal.Body>
            </Modal>
        );
    }
      

    

    const [currentPageGW, setCurrentPageGW] = useState(1);
    const [herb, setHerb] = useState({})
    const [drug, setDrug] = useState({})
    const [drugClass, setDrugClass] = useState({})

    const [inputs, setInputs] = useState([]);
    const [lastInputs, setLastInputs] = useState([]);
    const [interactingEntities, setInteractingEntities] = useState([]);
    const [lastInteractingEntities, setLastInteractingEntities] = useState([]);
    const [gatewayInteractionResults, setGatewayInteractionResults] = useState([]);
    const [totalCountGW, setTotalCountGW] = useState(0);
    const [rowsPerPage] = useState(20);
    const [noInteractionDisclaimer, setNoInteractionDisclaimer] = useState("")
    const [isResultFetched, setIsResultFetched] = useState(false);


    // 
    
    const [selectedHerb, setSelectedHerb] = useState(null);
    const [selectedDrug, setSelectedDrug] = useState(null);
    const [selectedDrugClass, setSelectedDrugClass] = useState(null);
    const [prevSelectedHerb, setPrevSelectedHerb] = useState(null);
    const [prevSelectedDrug, setPrevSelectedDrug] = useState(null);
    const [prevSelectedDrugClass, setPrevSelectedDrugClass] = useState(null);
    
    const handleMedicationChange = (type, event, value, trigger = false) => {
        console.log(`Selection changed: type=${type}, value=`, value);

        let newSelectedHerb = selectedHerb;
        let newSelectedDrug = selectedDrug;
        let newSelectedDrugClass = selectedDrugClass;
        
        if (!value) {
          if (type === "herbs") {
            newSelectedHerb = null;
            setSelectedHerb(null);
            setHerb(null);
          } else if (type === "drugs") {
            newSelectedDrug = null;
            setSelectedDrug(null);
            setDrug(null);
          } else if (type === "drugClass") {
            newSelectedDrugClass = null;
            setSelectedDrugClass(null);
            setDrugClass(null);
          }
        } else {
          const id = value.id;
          const label = value.name;
      
          if (type === "herbs") {
            newSelectedHerb = value;
            setSelectedHerb(value);
            setHerb({ id, name: label });
          } else if (type === "drugs") {
            newSelectedDrugClass = null;
            newSelectedDrug = value;
            setSelectedDrug(value);
            setDrug({ id, name: label });
            setSelectedDrugClass(null);
            setDrugClass(null);
          } else if (type === "drugClass") {
            newSelectedDrug = null;
            newSelectedDrugClass = value;
            setSelectedDrugClass(value);
            setDrugClass({ id, name: label });
            setSelectedDrug(null);
            setDrug(null);
          }
        }
      
        // Compute newInputs and newEntities from *updated* local state
        const newInputs = [];
        const newEntities = [];
        const newPage = 1;
        if (newSelectedHerb?.id) {
          newInputs.push({ id: newSelectedHerb.id, type: "herbs" });
          if (newSelectedDrug?.id) newEntities.push({ id: newSelectedDrug.id, type: "drugs" });
          if (newSelectedDrugClass?.id) newEntities.push({ id: newSelectedDrugClass.id, type: "drugClass" });
        } else {
          if (newSelectedDrug?.id) newInputs.push({ id: newSelectedDrug.id, type: "drugs" });
          if (newSelectedDrugClass?.id) newInputs.push({ id: newSelectedDrugClass.id, type: "drugClass" });
        }
        
        // Set states
        setInputs(newInputs);
        setInteractingEntities(newEntities);
        setCurrentPageGW(newPage);
        // Trigger API call directly to avoid stale state issue only if trigger is true
        if (trigger === true ) {
            setNoInteractionDisclaimer("");
            setLastInputs(newInputs);
            setLastInteractingEntities(newEntities)
            setPrevSelectedHerb(newSelectedHerb)
            setPrevSelectedDrug(newSelectedDrug)
            setPrevSelectedDrugClass(newSelectedDrugClass)
            if (newInputs.length > 0 ) {
                if (!isLgScreen){
                    setIsSearchModalOpen(false);
                } 
                showLoader();
                console.log("Triggering API with:", {
                    inputs: newInputs,
                    interactingEntities: newEntities,
                    currentPageGW : newPage,
                });     

                gatewayInteraction(newInputs, newEntities, newPage)
                    .then((items) => {
                    console.log("API response:", items);
                    if (items.status === 204) {
                        setGatewayInteractionResults([]);
                        setTotalCountGW(-1);
                    } else {
                        setGatewayInteractionResults(items.data.interactions);
                        setTotalCountGW(items.count);
                        setIsResultFetched (true);
                        if(items.count === 0){
                            setNoInteractionDisclaimer(items.data.noInteractionDisclaimer);
                            console.log("No interaction found: ",items.data.noInteractionDisclaimer);
                        }
                    }
                    
                    hideLoader();
                    })
                    .catch(() => {
                    hideLoader();
                    });
            } else {
            setGatewayInteractionResults([]);
            setIsResultFetched (false);
            }
        }
      };
      
    const handlePageChange = (event, newPage) => {
        showLoader();
        setCurrentPageGW(newPage);
        console.log("Turning to next page: ", newPage) 
        gatewayInteraction(inputs, interactingEntities, newPage)
            .then((items) => {
            console.log("API response:", items);
              if (items.status === 204) {
                setGatewayInteractionResults([]);
                setTotalCountGW(-1);
              } else {
                setGatewayInteractionResults(items.data.interactions);
                if(items.count === 0){
                    setNoInteractionDisclaimer(items.data.noInteractionDisclaimer);
                    console.log("No interaction found: ",items.data.noInteractionDisclaimer);
                }
              }
              hideLoader();
            })
            .catch(() => {
              hideLoader();
            });
        handleScrollUp();
    }
    
    // Inputs checker, if new inputs are the same as last used inputs, then disable the check interaction button
    const areSelectionsEqual = (a1, b1, a2, b2) => {
        const serialize = (arr) =>
          arr.map((item) => `${item.id}-${item.type}`).sort().join(",");
      
        return (
          a1.length === b1.length &&
          a2.length === b2.length &&
          serialize(a1) === serialize(b1) &&
          serialize(a2) === serialize(b2)
        );
      };
      
      

    useEffect(() => {
        logPage(
          "IMGateway",
          herb?.name ?? '',
          drug?.name ?? drugClass?.name ?? ''
        );
      }, [inputs, herb, drug, drugClass]);

    useEffect(() => {
        console.log("New Input:", inputs);
        console.log("last Input:", lastInputs);
        console.log("Updated results:", gatewayInteractionResults);
      }, [gatewayInteractionResults, inputs, lastInputs]);

    const clearAllImGatewayOnClick = () => {
        setInputs([])
        setLastInputs([])
        setInteractingEntities([])
        setLastInteractingEntities([])
        setGatewayInteractionResults([])
        setTotalCountGW(0)
        setCurrentPageGW(1)
        setSelectedHerb(null);
        setSelectedDrug(null);
        setSelectedDrugClass(null);
        setHerb({})
        setDrug({})
        setDrugClass({})
        setIsResultFetched (false);
    }

    
    //Severity
    const getRecommendationColor = (RecommendationLevel, isBorder = false) => {
        switch (RecommendationLevel) {
        case 5: return isBorder ? "#d32f2f" : "error";    // Red
        case 4: return isBorder ? "#ed6c02" : "warning";  // Orange
        case 3: return isBorder ? "#E0A201" : "default";  // Yellow
        case 2: return isBorder ? "#2e7d32" : "success";  // Green
        case 1: return isBorder ? "#1976d2" : "primary";  // Blue
        default: return isBorder ? "#727272" : "default"; // Gray (default MUI color)
        }
    };
    //Documentation Level
    const getEvidenceTypeColor = (level) => {
        switch (level) {
            case "Not Established": return "error"; // Not Established
            case "Limited": return "warning"; // Limited
            case "Good": return "success"; // Good
            case "Well Established": return "primary"; // Well Established
            default: return "default"; // Fallback color
        }
    };

    const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
    const handleOpenSearchDialog = () => {
        setIsSearchModalOpen(true);
    };
    const handleCloseSearchDialog = () => {
        setIsSearchModalOpen(false);
        setInputs(lastInputs);
        setInteractingEntities(lastInteractingEntities);
        setSelectedHerb (prevSelectedHerb);
        setSelectedDrug (prevSelectedDrug);
        setSelectedDrugClass (prevSelectedDrugClass);

    }

    const SearchPanel = useCallback(() => (
        <div id="IMGatewayQueryFilter" className={isFloating ? "floating" : ""} style={{
            top: isFloating ? '60px' : '40px',
            transition: 'top 0.4s ease'
        }}>
               <div className="w-100" style={{ display: 'flex', flexDirection: 'column', height: '100%', paddingBottom: !isResultFetched ?"40px" : " " }}>
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <h5 className="my-0" style= {{color: "#0262AB", fontWeight: "Bold"}}>Medications</h5>
                        <Button
                            disabled={inputs.length === 0}
                            variant="text"
                            color="error"
                            onClick={clearAllImGatewayOnClick}
                            startIcon={<IconTrash />}
                            sx={{ textTransform: "none" }}
                        >
                            Clear All
                        </Button>
                    </div>
                    <hr className='mb-3'/>
                    <FormControl fullWidth>
                        <FormLabel sx={{ fontWeight: "bold", marginBottom: "8px" }}>
                        Herb / Supplement / Food
                        </FormLabel>
                        <Autocomplete
                        blurOnSelect
                        options={entities.herbs || []}
                        getOptionLabel={(option) => (option && option.name) ? option.name : ''}
                        value={
                            selectedHerb && entities.herbs?.length
                              ? entities.herbs.find((option) => option.id === selectedHerb.id) || null
                              : null
                          }
                        onChange={(event, value) => {
                            if (value){
                                setSelectedHerb(value);
                                handleMedicationChange('herbs', event, value, isLgScreen);
                            }
                          }}
                          onInputChange={(event, newInputValue, reason) => {
                            if (reason === 'clear') {
                              setSelectedHerb(null);
                              handleMedicationChange('herbs', event, null, isLgScreen);
                            }
                          }}
                        renderInput={(params) => (
                            <TextField {...params} placeholder="Select Herb/Supplement/Food" fullWidth />
                        )}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        />
                    </FormControl>
                    <Divider textAlign="center" variant="middle"  sx={{ borderBottomWidth: '3px', mx:0, my: isLgScreen? 2 : 1}}>
                        <IconCirclePlusFilled size={isLgScreen ? 40:20} style={{color: "#0262AB"}}/>
                    </Divider>
                    
                    <FormControl fullWidth>
                        <FormLabel sx={{ fontWeight: "bold", marginBottom: "8px" }}>
                        Drug
                        </FormLabel>
                        <Autocomplete
                        blurOnSelect
                        options={entities.drugs || []}
                        getOptionLabel={(option) => (option && option.name) ? option.name : ''}
                        value={
                            selectedDrug && entities.drugs?.length
                              ? entities.drugs.find((option) => option.id === selectedDrug.id) || null
                              : null
                          }
                        onChange={(event, value) => {
                            if (value){
                                setSelectedDrug(value);
                                handleMedicationChange('drugs', event, value, isLgScreen);
                            }
                          }}
                        onInputChange={(event, newInputValue, reason) => {
                            if (reason === 'clear') {
                              setSelectedDrug(null);
                              handleMedicationChange('drugs', event, null, isLgScreen);
                            }
                          }}
                        renderInput={(params) => (
                            <TextField {...params} placeholder="Select Drug" fullWidth />
                        )}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        />
                    </FormControl>
                    <Divider sx={{my: isLgScreen? 2 : 1}}>
                        <Chip style={{fontWeight: "bold",}} label="OR" size="small" />
                    </Divider>
                    <FormControl fullWidth>
                        <FormLabel sx={{ fontWeight: "bold", marginBottom: "8px" }}>
                        Drug Class
                        </FormLabel>
                        <Autocomplete
                        blurOnSelect
                        options={entities.drugClass || []}
                        getOptionLabel={(option) => (option && option.name) ? option.name : ''}
                        value={
                            selectedDrugClass && entities.drugClass?.length
                              ? entities.drugClass.find((option) => option.id === selectedDrugClass.id) || null
                              : null
                          }
                        onChange={(event, value) => {
                            if (value){
                                setSelectedDrugClass(value);
                                handleMedicationChange('drugClass', event, value, isLgScreen);
                            }
                          }}
                        onInputChange={(event, newInputValue, reason) => {
                            if (reason === 'clear') {
                              setSelectedDrugClass(null);
                              handleMedicationChange('drugClass', event, null, isLgScreen);
                            }
                          }}
                        renderInput={(params) => (
                            <TextField {...params} placeholder="Select Drug Class" fullWidth />
                        )}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        />
                    </FormControl>
                    {!isLgScreen && (
                    <Button
                        disabled={
                            inputs.length === 0 ||
                            areSelectionsEqual(inputs, lastInputs, interactingEntities, lastInteractingEntities)
                          }
                        variant="contained"
                        type="submit"
                        onClick={() => handleMedicationChange(null, null, null, true)}
                        fullWidth
                        sx={{
                        borderRadius: "16px",
                        minWidth: 0,
                        padding: "16px",
                        backgroundColor: "#0262AB",
                        whiteSpace: "nowrap",
                        marginTop: "auto",
                        }}
                        startIcon={<IconZoomCheckFilled />}
                    >
                       Check Interactions
                    </Button>
                )}
                </div>
                
                
            </div>

    ), [
        clearAllImGatewayOnClick,
        setSelectedHerb,
        setSelectedDrug,
        setSelectedDrugClass,
        handleMedicationChange,
        isFloating
      ]);
    const [isTabsFloating, setIsTabsFloating] = useState(false);
   
    return (
        <>
        <Helmet>
            <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>
       
        <Banner />
        <ResultModal
            show={modalShow}
            onHide={() => setModalShow(false)}
        />
        <ReportModal
            show={modalShow}
            onHide={() => {
                setShowReportModal(false);
                setModalShow(true);
            }}
        />

        <Sidebar activeButton={activeButton} />
        <div id="IMGateway">
            <Container fluid id="main">
                <Row id="content">
                    <Col>
                        <div id="contentCaption">
                            <h2>IMGateway Herbal Interactions</h2>
                            {isLgScreen && (
                                <span>Check interactions between complementary and conventional medicines.</span>
                            )}
                        </div>
                        {/* Sentinel for triggering float */}
                        <div ref={sentinelRef} style={{ height: '1px' }}></div>
                        <Row className={ isLgScreen ? 'my-3 d-flex flex-row' : ''}  
                            style={{ height: !isLgScreen && isResultFetched !== true ? "100%" : "", margin: !isLgScreen ? 0 : "" }}>
                            <Col id="queryContainer" md={12} lg={4} 
                            style={{ 
                                height: !isLgScreen && isResultFetched !== true ? "" : "100%",
                                paddingTop: !isLgScreen && isResultFetched !== true ? "32px" : ""}}>
                                {isLgScreen ? (
                                    //  Always show SearchPanel on large screens
                                    SearchPanel()
                                ) : isResultFetched === true ? (
                                    //  On small screens *after* results, show button + dialog
                                    <>
                                    <Button
                                        variant="contained"
                                        sx={{padding: "16px 32px",
                                            borderRadius: "16px",
                                            backgroundColor: "#0262AB",
                                            marginBottom: "16px"}}
                                        fullWidth
                                        startIcon={<IconSearch/>}
                                        onClick={handleOpenSearchDialog}
                                    >
                                        Open Medications Filters
                                    </Button>

                                    <Dialog
                                        open={isSearchModalOpen}
                                        onClose={handleCloseSearchDialog}
                                        id="IMGatewaySearchPanelModal"
                                    >
                                        <DialogContent>
                                        {SearchPanel()}
                                        </DialogContent>
                                    </Dialog>
                                    </>
                                ) : (
                                    //  On small screens, only show SearchPanel *before* results
                                    SearchPanel()
                                )}
                            </Col>
                            <Col id="resultsContainer" lg={8} md={12} 
                                style={{ display: !isLgScreen && isResultFetched !== true ? "none" : "block", height: isResultFetched ? "fit-content" : "" }}>
                                <Box height={isResultFetched ? "fit-content" : "100%"} width={"100%"} >
                                    {isResultFetched === true ? (<>
                                        {isLgScreen && (<>
                                        <div className='d-flex align-items-center '>
                                            <h4 className="align-self-start m-0">Interaction Results </h4>
                                            <Chip 
                                                label={totalCountGW} 
                                                size="small" 
                                                className="totalChip"
                                                color={totalCountGW > 0 ? "error" : "default" } 
                                            />
                                        </div>
                                        <hr className='mb-3'/>
                                        </>
                                        )} 
                                        {!noInteractionDisclaimer ? (<>
                                            <label style={{fontSize : 14}}>
                                                Showing {
                                                    totalCountGW > 20 ? (
                                                    `${(currentPageGW * rowsPerPage) + 1 - rowsPerPage}-${Math.min(totalCountGW, currentPageGW * rowsPerPage)} of ${totalCountGW} results`
                                                    ) : (
                                                    totalCountGW > 1 ? `${totalCountGW} results` : `${totalCountGW} result`
                                                    )
                                                }
                                            </label>
                                            {isLgScreen ? (<>
                                                <TableContainer component={Paper} sx={{ mt: 2 }} >
                                                    <Table aria-label="simple table" >
                                                        <TableHead>
                                                        <TableRow style={{fontSize:"8px"}}>
                                                            <TableCell sx={{px:0}}>Herb/Supplement/Food</TableCell>
                                                            <TableCell sx={{px:0}}>Drug</TableCell>
                                                            <TableCell sx={{px:0}}>Drug class</TableCell>
                                                            <TableCell sx={{px:0}} align="center">Recommendation</TableCell>
                                                            <TableCell sx={{px:0}} align="center">Evidence Type</TableCell>
                                                            <TableCell sx={{px:0}}></TableCell> {/* Empty header for button */}
                                                        </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                        {gatewayInteractionResults && gatewayInteractionResults.map((val) => (
                                                            <TableRow
                                                            key={val.generalInteractionId}
                                                            data-route="mic"
                                                            data-herb={val.herb}
                                                            data-drug={val.drug}
                                                            data-drugClass={val.drugClass}
                                                            data-recommendation={val.recommendation}
                                                            data-recommendationRanking={val.recommendationRanking}
                                                            data-patientadvise={val.patientAdvice}
                                                            data-evidenceType={val.evidenceType}
                                                            data-generalCommentary={val.commentaryOnEvidence}
                                                            data-reports={JSON.stringify(val.reports)}
                                                            onClick={OnClickedTableRow}
                                                            sx={{
                                                                cursor: "pointer",
                                                                "&:hover": { backgroundColor: "#f5f5f5" },
                                                            }}
                                                            >
                                                            <TableCell>{val.herb}</TableCell>
                                                            <TableCell>{val.drug}</TableCell>
                                                            <TableCell>{val.drugClass}</TableCell>
                                                            <TableCell>
                                                                <Chip
                                                                    label={val.recommendation}
                                                                    color={getRecommendationColor(val.recommendationRanking)}
                                                                    style={{
                                                                    backgroundColor: val.recommendationRanking === 3 ? "#E0A201" : undefined,
                                                                    color:  val.recommendationRanking === 3 ? "#ffffff" : undefined,
                                                                    fontSize: "12px"
                                                                    }}
                                                                />
                                                            </TableCell>
                                                            <TableCell>
                                                            <Chip
                                                                label={val.evidenceType}
                                                                color={getEvidenceTypeColor(val.evidenceType)}
                                                                variant="outlined"
                                                                sx={{ borderWidth: "3px", borderStyle: "solid" }}
                                                                />
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <Button variant="text" size="small" sx={{ minWidth: 0, p: 0 }}>
                                                                <IconExternalLink color="#0262AB" size={16} />
                                                                </Button>
                                                            </TableCell>
                                                            </TableRow>
                                                        ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </>):(<>
                                                <Row className='mb-1 py-2'style={{ fontSize: 10, fontWeight: "bold", alignItems: "center", backgroundColor: "#dee2e6",  marginTop: isTabsFloating ? "12px" : "0.5rem"}}>
                                                    <Col xs={8} md={8}>
                                                        <span>Medications</span>
                                                    </Col>
                                                    <Col xs={4} md={4} style={{textAlign: "center"}}>
                                                    <span> Recommendation/<br/>Evidence </span>
                                                    </Col>
                                                </Row>
                                                {gatewayInteractionResults && gatewayInteractionResults.map((val) => (
                                                     <Row
                                                     className='mobileRows'
                                                     style={{ fontSize: 12 }}
                                                     key={val.generalInteractionId}
                                                     data-route="mic"
                                                     data-herb={val.herb}
                                                     data-drug={val.drug}
                                                     data-drugClass={val.drugClass}
                                                     data-recommendation={val.recommendation}
                                                     data-recommendationRanking={val.recommendationRanking}
                                                     data-patientadvise={val.patientAdvice}
                                                     data-evidenceType={val.evidenceType}
                                                     data-generalCommentary={val.commentaryOnEvidence}
                                                     data-reports={JSON.stringify(val.reports)}
                                                     onClick={OnClickedTableRow}
                                                   >
                                                           <Col xs={8} md={8}>
                                                                <div>
                                                                    <span style={{ fontSize: 10 }}>Herb: </span>
                                                                    <span style={{ color: "#0262AB" }}>
                                                                    {val.herb}
                                                                    </span>
                                                                </div>

                                                                {val.drug && (
                                                                <div>
                                                                    <span style={{ fontSize: 10 }}>Drug: </span>
                                                                    <span style={{ color: "#0262AB" }}>
                                                                        {val.drug}
                                                                    </span>
                                                                </div>
                                                                )}

                                                                {val.drugClass && (
                                                                <div>
                                                                    <span style={{ fontSize: 10 }}>Drug Class: </span>
                                                                    <span style={{ color: "#0262AB" }}>
                                                                        {val.drugClass}
                                                                    </span>
                                                                 </div>
                                                                )}
                                                            </Col>


                                                            <Col xs={4} md={4}>
                                                            <List style={{padding: 0}}>
                                                                <ListItem style={{padding: 0, paddingBottom: "4px", justifyContent: "end", width: "100%"}}>
                                                                <ListItemIcon style={{  width: "100%" }}>
                                                                    <Chip
                                                                    size="small"
                                                                    label={val.recommendation}
                                                                    color={getRecommendationColor(val.recommendationRanking)}
                                                                    style={{
                                                                        fontWeight: "bold",
                                                                        textAlign: "center",
                                                                        width: "100%",
                                                                        backgroundColor: val.recommendationRanking === 3 ? "#E0A201" : undefined,
                                                                        color:  val.recommendationRanking === 3 ? "#ffffff" : undefined,
                                                                    }}
                                                                    />
                                                                </ListItemIcon>
                                                                </ListItem>
                                                                <ListItem style={{padding: 0, justifyContent: "end",  width: "100%"}}>
                                                                <ListItemIcon style={{  width: "100%" }}>
                                                                    <Chip
                                                                    size="small"
                                                                    label={val.evidenceType}
                                                                    color={getEvidenceTypeColor(val.evidenceType)}
                                                                    variant="outlined"
                                                                    style={{
                                                                        fontWeight: "bold",
                                                                        textAlign: "center",
                                                                        width: "100%",
                                                                    }}
                                                                    />
                                                                </ListItemIcon>
                                                                </ListItem>
                                                            </List>
                                                            </Col>
                                                            <Col xs={8} md={8}>
                                                            
                                                            </Col>
                                                            <Col xs={4} md={4} style={{display: "flex", alignItems:"center", justifyContent: "end", margin: "8px 0"}}>
                                                                <IconArrowRight color="#0262AB" size={16} />
                                                            
                                                            </Col>
                                                            <hr className='m-0'/>
                                                        </Row>
                                                )
                                            )}
                                            </>)}
                                            
                                            <div className="pagination-container d-flex mt-4" style={{marginBottom: isLgScreen ? "" :"20px"}}>
                                                <Pagination
                                                    count={Math.ceil(totalCountGW / rowsPerPage)}
                                                    page={currentPageGW}
                                                    onChange={(event, newPage) => {
                                                        if (newPage !== currentPageGW) {
                                                        handlePageChange(event, newPage);
                                                        }
                                                    }}
                                                    showFirstButton
                                                    showLastButton
                                                    siblingCount={isLgScreen ? 2 : 0}
                                                    boundaryCount={isLgScreen ? 2 : 1}
                                                />
                                            </div>

                                        </>):(<>
                                            <div className="noResultAlert" style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: "40px" }}>
                                            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
                                                {/* Column 1: Icon */}
                                                <IconInfoTriangleFilled size={92} color="#0061AA" style={{ marginRight: '16px', flexShrink: 0 }} />

                                                {/* Column 2: Title and First Paragraph */}
                                                <div style={{ flex: 1 }}>
                                                    {/* Title */}
                                                    <h4 style={{ margin: 0, marginBottom: 8, fontWeight: "bold" }}>No interaction records found</h4>
                                                    {/* AllergyDisclaimer */}
                                                    <p style={{ margin: 0 }}>
                                                        {parse(noInteractionDisclaimer.toString())}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                            
                                        </>)}
                                        <Zoom
                                        in={isFloatingMobile}
                                        timeout={transitionDuration}
                                        unmountOnExit
                                        >
                                            <Fab
                                                color="primary"
                                                aria-label="add"
                                                sx={{
                                                position: 'fixed',
                                                bottom: 80,
                                                right: 20,
                                                zIndex: 100,
                                                backgroundColor: "#0262AB"
                                                }}
                                                onClick={handleOpenSearchDialog}
                                            >
                                                <IconSearch />
                                            </Fab>
                                        </Zoom>
                                        
                                    </>):(<>
                                        <div id="illustration-container">
                                            <h6 style={{lineHeight: 1.5}}>USE THE SEARCH FILTERS TO CHECK HERBAL INTERACTIONS.</h6>
                                            <img src={Illustration} alt="Illustration" id="illustration" style={{ maxWidth: '100%', height: 'auto' }} />
                                        </div>
                                    </>)}
                                    
                                </Box>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Zoom
                    in={isFloating && isLgScreen}
                    timeout={transitionDuration}
                    unmountOnExit
                    >
                        <Fab
                            color="primary"
                            aria-label="add"
                            sx={{
                            position: 'fixed',
                            bottom: 40,
                            right: 40,
                            zIndex: 100,
                            backgroundColor: "#0262AB"
                            }}
                            variant="extended"
                            onClick={handleScrollUp}
                            size="medium"
                        >
                                <IconArrowBadgeUpFilled sx={{ mr: 2 }} />
                                Scroll Up
                        </Fab>
                    </Zoom>
            </Container>
        </div>
        </>

    );
}

export default IMGatewayHerbalInteractions;